import apiClient from "./Api";

// This will be set by the ErrorProvider when the app initializes
let errorHandlerCallback = null;
let interceptorsSetup = false;

export const setErrorHandler = (handler) => {
  errorHandlerCallback = handler;
};

export const setupInterceptors = () => {
  if (interceptorsSetup) return;
  interceptorsSetup = true;
  apiClient().interceptors.request.use(
    (config) => {
      let accessToken = localStorage.getItem('accessToken');

      // Only set Authorization header if we have a valid token
      if (accessToken) {
        try {
          // Trim any whitespace and ensure it's a valid string
          accessToken = accessToken.trim();
          config.headers.Authorization = `Bearer ${accessToken}`;
        } catch (error) {
          console.error('Error setting Authorization header:', error);
          // Don't set the header if there's an error
        }
      }

      return config;
    },
    (error) => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  apiClient().interceptors.response.use((response) => {
    return response;
  }, (err) => {
    // Check if this is a network/connection error that should show a global popup
    const isNetworkError = !err.response ||
                           err.code === 'ERR_NETWORK' ||
                           err.code === 'ECONNABORTED' ||
                           err.code === 'ERR_SOCKS_CONNECTION_FAILED' ||
                           err.response?.status === 408 ||
                           err.response?.status === 504;

    // Show global error popup for network/connection errors
    // Note: "TBD" is the required error message as per story MPP-3320 acceptance criteria
    if (isNetworkError && errorHandlerCallback) {
      errorHandlerCallback('TBD');
    }

    return Promise.reject(err);
  });
};